// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609111334/js/" + chunkId + "." + {"44":"9717dbb3","225":"de9f85af","481":"96af475d","486":"04c2080b","770":"b198c849"}[chunkId] + ".0.7415817145077465.chunk.js";
};